import styled from 'styled-components';
import { Colors } from '../../../theme';
import { breakpointLG, breakpointSM } from '../styles/breakpoints';
import { button } from '../styles/fonts';
import { StyledLinkV2 } from '../styles/ui';
import { HEADER_TYPE } from '../types';
export const Wrapper = styled.section `
  position: fixed;
  bottom: 0;
  left: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding: 16px;
  margin: 0 auto;
  background-color: ${Colors.white};

  ::before {
    position: absolute;
    top: 0;
    left: 16px;
    width: calc(100% - 32px);
    height: 1px;
    content: '';
    background-color: ${({ $type }) => $type === HEADER_TYPE.Integrated ? 'transparent' : Colors.grey200};
  }

  @media (min-width: ${breakpointSM}) {
    flex-direction: row;
    justify-content: center;
    padding: 24px;

    &::before {
      left: 24px;
      width: calc(100% - 48px);
    }
  }

  @media (min-width: ${breakpointLG}) {
    display: none;
  }
`;
export const CustomLink = styled(StyledLinkV2) `
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: 2px solid ${Colors.blue300};
  border-radius: 12px;
  padding: 8px;
  height: 48px;
  min-width: 76px;
  max-width: 100%;
  ${button}

  &:hover {
    color: ${Colors.grey900};
    background-color: ${Colors.blue400};
    border: 2px solid ${Colors.blue400};
  }

  &.MuiLink-root {
    &:focus,
    &:active {
      color: ${Colors.grey900};
      background-color: ${Colors.blue300};
      border: 2px solid ${Colors.blue300};
      outline: 2px solid ${Colors.white};
      outline-offset: -4px;
    }
  }

  @media (min-width: ${breakpointSM}) {
    max-width: 300px;
  }
`;
export const RegistrationLink = styled(StyledLinkV2) `
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid ${Colors.blue300};
  background-color: ${Colors.blue300};
  border-radius: 12px;
  padding: 8px;
  height: 48px;
  min-width: 76px;
  max-width: 100%;
  ${button}

  &:hover {
    background-color: ${Colors.blue400};
    border: 2px solid ${Colors.blue400};
  }

  &.MuiLink-root {
    &:focus,
    &:active {
      color: ${Colors.grey900};
      border: 2px solid ${Colors.blue300};
      outline: 2px solid ${Colors.white};
      outline-offset: -4px;
    }
  }

  @media (min-width: ${breakpointSM}) {
    max-width: 300px;
  }
`;
//# sourceMappingURL=styles.js.map